/**
 * Система — здоровье платформы для команды: жив ли фоновый воркер (триалы,
 * напоминания, пуши), журнал запусков задач, доставляемость пушей и общие
 * шаблоны WhatsApp.
 *
 * Шаблоны стоят здесь, а не в настройках клиники: они общие для всех
 * клиник, и правит их только Skrezo.
 *
 * Данные — GET admin/jobs, admin/jobs/runs, admin/notifications/telemetry,
 * admin/whatsapp/templates.
 */

import {RunsCard} from './RunsCard';
import {TelemetryCard} from './TelemetryCard';
import {TemplatesCard} from './TemplatesCard';
import {WorkerCard} from './WorkerCard';

export const System = () => (
  <>
    <header className="sticky top-0 z-10 border-b border-skr-line bg-background/80 px-[30px] py-[18px] backdrop-blur max-md:px-4">
      <h1 className="text-[21px] font-bold -tracking-[.02em]">Система</h1>
      <div className="mt-0.5 text-[13px] text-muted-foreground">
        Фоновые задачи, доставка уведомлений и общие шаблоны
      </div>
    </header>
    <div className="grid max-w-[1180px] grid-cols-2 items-start gap-4 px-[30px] pb-[60px] pt-[22px] max-lg:grid-cols-1 max-md:px-4">
      <div className="flex flex-col gap-4">
        <WorkerCard />
        <TelemetryCard />
        <TemplatesCard />
      </div>
      <RunsCard />
    </div>
  </>
);
